module.exports = __webpack_public_path__ + "static/lineto-circular-medium-b77d1356830fa186df16b3513e907009.woff";